var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.95604 4.23618C1.5 5.20182 1.5 6.58054 1.5 9C1.5 11.8123 1.5 13.2184 2.21619 14.2042C2.44748 14.5225 2.72745 14.8025 3.04581 15.0338C4.03155 15.75 5.4377 15.75 8.25 15.75H9.75C12.5623 15.75 13.9684 15.75 14.9542 15.0338C15.2726 14.8025 15.5525 14.5225 15.7838 14.2042C16.5 13.2184 16.5 11.8123 16.5 9C16.5 6.56344 16.5 5.18239 16.0342 4.21577M1.95604 4.23618C2.03008 4.0794 2.11615 3.9335 2.21619 3.79581C2.44748 3.47745 2.72745 3.19748 3.04581 2.96619C4.03155 2.25 5.4377 2.25 8.25 2.25H9.75C12.5623 2.25 13.9684 2.25 14.9542 2.96619C15.2726 3.19748 15.5525 3.47745 15.7838 3.79581C15.8795 3.92751 15.9624 4.06671 16.0342 4.21577M1.95604 4.23618L2.25 4.5L3.6967 5.9467C6.1967 8.4467 7.4467 9.6967 9 9.6967C10.5533 9.6967 11.8033 8.4467 14.3033 5.9467L15.75 4.5L16.0342 4.21577",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.9fbea8a37a7a458b4d42fd7ab751be3e.svg";
export { ForwardRef as ReactComponent };